export enum LmsTrainingsTableFields {
  id = 'id',
  externalId = 'externalId',
  title = 'title',
  description = 'description',
  url = 'url',
  createdAt = 'createdAt',
  actions = 'actions',
}
